import { useRef, useState } from "react";
import { Overlay } from "react-bootstrap";
import IcomoonIcon from "@icons/IcomoonIcon";

interface SntTooltipProps {
  size?: number;
  className?: string;
  text: string | React.ReactNode;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

const SntTooltip: React.FC<SntTooltipProps> = ({
  size = 16,
  className = "",
  text,
  icon,
  style = {},
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [show, setShow] = useState<boolean>(false);

  return (
    <span
      ref={ref}
      className={`${className}`}
      style={style}
      onMouseEnter={() => setShow(!show)}
      onMouseLeave={() => setShow(false)}
    >
      {icon ? icon : <IcomoonIcon icon="question" size="16"></IcomoonIcon>}
      <Overlay target={ref.current} show={show}>
        {/* https://github.com/react-bootstrap/react-overlays/issues/312 */}
        {({
          placement,
          scheduleUpdate,
          arrowProps,
          outOfBoundaries,
          show,
          ...props
        }) => (
          <div className="snt-tooltip" {...props}>
            {text}
          </div>
        )}
      </Overlay>
    </span>
  );
};
export default SntTooltip;
